/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FavoriteHotel
 */
export interface FavoriteHotel {
    /**
     * 
     * @type {number}
     * @memberof FavoriteHotel
     */
    propertyId: number;
    /**
     * 
     * @type {string}
     * @memberof FavoriteHotel
     */
    propertyName: string;
    /**
     * 
     * @type {string}
     * @memberof FavoriteHotel
     */
    propertyAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof FavoriteHotel
     */
    heroImage?: string;
    /**
     * 
     * @type {string}
     * @memberof FavoriteHotel
     */
    chainName?: string;
    /**
     * 
     * @type {Date}
     * @memberof FavoriteHotel
     */
    favoritedAt: Date;
}

/**
 * Check if a given object implements the FavoriteHotel interface.
 */
export function instanceOfFavoriteHotel(value: object): value is FavoriteHotel {
    if (!('propertyId' in value) || value['propertyId'] === undefined) return false;
    if (!('propertyName' in value) || value['propertyName'] === undefined) return false;
    if (!('favoritedAt' in value) || value['favoritedAt'] === undefined) return false;
    return true;
}

export function FavoriteHotelFromJSON(json: any): FavoriteHotel {
    return FavoriteHotelFromJSONTyped(json, false);
}

export function FavoriteHotelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FavoriteHotel {
    if (json == null) {
        return json;
    }
    return {
        
        'propertyId': json['property_id'],
        'propertyName': json['property_name'],
        'propertyAddress': json['property_address'] == null ? undefined : json['property_address'],
        'heroImage': json['hero_image'] == null ? undefined : json['hero_image'],
        'chainName': json['chain_name'] == null ? undefined : json['chain_name'],
        'favoritedAt': (new Date(json['favorited_at'])),
    };
}

export function FavoriteHotelToJSON(json: any): FavoriteHotel {
    return FavoriteHotelToJSONTyped(json, false);
}

export function FavoriteHotelToJSONTyped(value?: FavoriteHotel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'property_id': value['propertyId'],
        'property_name': value['propertyName'],
        'property_address': value['propertyAddress'],
        'hero_image': value['heroImage'],
        'chain_name': value['chainName'],
        'favorited_at': value['favoritedAt'].toISOString(),
    };
}

